<script setup>
/**
 * Import packages
 */
import { defineComponent } from 'vue';

/**
 * Component Name
 */
defineComponent({
  name: 'VTableHead',
});
</script>

<template>
  <div class="v-table-head">
    <slot />
  </div>
</template>
